var _path;

function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }

import * as React from "react";

function SvgOffer(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.90482 0L16.154 1.17917L17.3323 9.42917L9.67232 17.0892C9.51605 17.2454 9.30413 17.3332 9.08316 17.3332C8.86219 17.3332 8.65026 17.2454 8.49399 17.0892L0.243989 8.83917C0.0877629 8.68289 0 8.47097 0 8.25C0 8.02903 0.0877629 7.81711 0.243989 7.66083L7.90482 0ZM8.49399 1.76833L2.01149 8.25L9.08316 15.3208L15.5648 8.83917L14.6815 2.65167L8.49399 1.76833ZM10.2607 7.07167C9.94803 6.75893 9.77245 6.33482 9.77252 5.89262C9.77256 5.67367 9.81573 5.45687 9.89955 5.2546C9.98338 5.05233 10.1062 4.86855 10.2611 4.71375C10.4159 4.55895 10.5997 4.43617 10.802 4.35242C11.0043 4.26867 11.2212 4.22558 11.4401 4.22562C11.8823 4.2257 12.3064 4.40143 12.619 4.71417C12.9316 5.0269 13.1072 5.45102 13.1071 5.89321C13.107 6.33541 12.9313 6.75946 12.6186 7.07208C12.3058 7.38471 11.8817 7.56029 11.4395 7.56021C10.9973 7.56014 10.5733 7.3844 10.2607 7.07167Z",
    fill: "black"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOffer);
export default __webpack_public_path__ + "static/media/offer.6d7f2b965e7becb9c49ac59638cfc8dd.svg";
export { ForwardRef as ReactComponent };